export const moduleName = 'menu'

export const CLOSE_MENU = `${moduleName}/CLOSE_MENU`

export const OPEN_MENU = `${moduleName}/OPEN_MENU`
